
import { BTN_VIEW_RACE_2D, ORANGE_LINE_LEAN_LEFT, ORANGE_LINE_LEAN_RIGHT, POLYGON } from 'assets/images'

import { RaceStatus } from 'models'
import { formatTime } from 'utils/helper'
import BoardViewTimeStyled from './styled'

interface BoardViewTimeProps {
  viewRace2D: (value: boolean) => void
  idRaceDetail: number | undefined
  disableRaceTable: (value: boolean) => void
  firstTime: number
  status: string
  toggleIsRaceEnd: (value: boolean) => void
}

function BoardViewTime({
  viewRace2D,
  disableRaceTable,
  firstTime,
  status,
  toggleIsRaceEnd
}: BoardViewTimeProps) {
  const timeWaitingDown = formatTime(firstTime)

  const handleViewRace2D = () => {
    toggleIsRaceEnd(false)
    viewRace2D(true)
    disableRaceTable(false)
  }

  const { SCHEDULING, CLOSED } = RaceStatus

  const handleDisplayBoardView = () => {
    let resultBoardView = null
    if (status && status === CLOSED) {
      resultBoardView = <div className='finished-race font-bold'>FINISHED RACE</div>
    } else if (status === SCHEDULING) {
      resultBoardView = <div className='processing-race font-bold'>Processing...</div>
    } else {
      resultBoardView = (
        <>
          <div className='time-remains font-bold'>TIME REMAINS</div>
          <div className='display-time font-bold'>
            <span>{timeWaitingDown?.split(':').join('\u00a0 \u00a0')}</span>
          </div>
          <div className='hour-min-sec font-bold'>
            <span>Hour</span>
            <span>Min</span>
            <span>Sec</span>
          </div>
        </>
      )
    }
    return resultBoardView
  }

  return (
    <BoardViewTimeStyled>
      <div className='board-view-time'>
        {handleDisplayBoardView()}
        <div className='orange-line-lean pb-3'>
          <div className='orange-line-lean-left'>
            <div>
              <img src={ORANGE_LINE_LEAN_LEFT} alt='' />
            </div>
          </div>
          <div className='polygon'>
            <img src={POLYGON} alt='' />
          </div>
          <div className='orange-line-lean-right'>
            <div>
              <img src={ORANGE_LINE_LEAN_RIGHT} alt='' />
            </div>
          </div>
        </div>
        {status !== SCHEDULING && (
          <div className='btn-view-race-2d'>
            <div onClick={() => handleViewRace2D()}>
              <img src={BTN_VIEW_RACE_2D} alt='' />
            </div>
          </div>
        )}
      </div>
    </BoardViewTimeStyled>
  )
}

export default BoardViewTime
